class LocationMap {
  constructor(element) {
    this.element = element?.jquery ? element[0] : element;

    if (!this.element || !this.element.querySelectorAll) {
      console.error("LocationMap: Ungültiges Element", element);
      return;
    }

    this.buttons = this.element.querySelectorAll("[data-location-map-button]");

    this.images = this.element.querySelectorAll("[data-location-map-image]");

    this.bindEvents();
    this.showImage("makro");
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.showImage(button.dataset.locationMapButton);
      });
    });
  }

  showImage(type) {
    this.images.forEach((image) => {
      const isActive = image.dataset.locationMapImage === type;

      image.classList.toggle("location-map__image--active", isActive);
    });

    this.buttons.forEach((button) => {
      const isActive = button.dataset.locationMapButton === type;

      button.setAttribute("aria-pressed", String(isActive));
    });
  }
}

export default LocationMap;
